import { formularioMostrar } from './formularioMostrar'
import { resetTimer } from './resetTimer'

export function showInactivityModal(segundosInactividad) {
  const urlsNoMostrarModalInactividad = {
    url1: 'https://segurosdecoche.mapfre.es/agr/',
    url2: 'https://segurosdemoto.mapfre.es/agr/',
    url3: 'https://segurosdehogar.mapfre.es/agr/',
    url4: 'https://segurosdesalud.mapfre.es/agr/',
    url5: 'https://seguroparamascotas.mapfre.es/agr/',
    url6: 'https://segurosdeviajes.mapfre.es/agr/',
    url7: 'https://segurodecesos.mapfre.es/agr/'
  }

  const urlActual = window.location.origin + window.location.pathname

  for (const urlNo in urlsNoMostrarModalInactividad) {
    if (urlActual === urlsNoMostrarModalInactividad[urlNo]) {
      console.log('Url sin modal Inactividad')
      return
    }
  }

  let idleTime = 0
  let warningFlag = 0
  setInterval(function checkIdle() {
    idleTime += 1
    // console.log("idleTime: " + idleTime)
    if (idleTime > segundosInactividad && warningFlag === 0) {
      formularioMostrar()

      warningFlag = 1
    }
    document.onload = () => resetTimer(idleTime)
    document.onmousemove = () => resetTimer(idleTime)
    document.onkeydown = () => resetTimer(idleTime)
    document.onmousemove = () => resetTimer(idleTime)
    document.onscroll = () => resetTimer(idleTime)
    document.ontouchmove = () => resetTimer(idleTime)
  }, 1000)
  console.log('Añadiendo funcionalidad modales')
}
